/* global FileReader */
export default () => ({
  handleChange(e) {
    if (!e.target.files.length) {
      this.$wire.set("fileName", null);
      this.$wire.set("privateKey", null);
      return;
    }
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      this.$wire.set("fileName", file.name);
      this.$wire.set("privateKey", e.target.result);
    };
    reader.readAsText(file);
  },
});
